import { render, staticRenderFns } from "./TagCloud.vue?vue&type=template&id=234b37bd&scoped=true&"
import script from "./TagCloud.vue?vue&type=script&lang=js&"
export * from "./TagCloud.vue?vue&type=script&lang=js&"
import style0 from "./TagCloud.vue?vue&type=style&index=0&id=234b37bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b37bd",
  null
  
)

export default component.exports